document.body.addEventListener("change", function (e) {
  // e.target is start point of bubbling

  if (e.target.getAttribute("name") == "purchaseOption") {
    checkMainPriceDisplay();
  }
});

/* Make abo tab active based on attribute value */
document.addEventListener("readystatechange", function () {
  if ($(".main-product").length > 0) {

  $('.onetime_label').appendTo('.onetime-radio').addClass('svisible');
    $('.subscription_label').appendTo('.subscription-radio').addClass('svisible');
    $('.subscription_custom').appendTo('.subscription-radio').addClass('svisible');
    
    const makeAboTabActive = $(".main-product").data("default-tab-abo");
    setTimeout(function () {
      if (makeAboTabActive == "1") {
        $(".subscription-radio").trigger("click");
        console.log("click sub radio");
      }
    }, 1000);
  }
});


const setCouponPrice = (newPrice, productVariantRef) => {
  const couponCode = document.querySelector("coupon-code");
  if (couponCode) {
    const cap = couponCode.querySelector(".coupon-code__compareAtPrice");

    cap.textContent = productVariantRef._formatMoney(
      newPrice,
      KROWN.settings.shop_money_format
    );

    const price = couponCode.querySelector(".coupon-code__price");
    price.textContent = productVariantRef._formatMoney(
      newPrice - (newPrice * couponCode.getAttribute("data-percentage")) / 100,
      KROWN.settings.shop_money_format
    );
  }
};

/*
function checkMainPriceDisplay(variant = false) {
  console.log("display changes");
  if (variant) {
    //console.log(variant);
    const unitPrice = variant.unit_price;
    const productVariantRef = document.querySelector("product-variants");
    const unitPriceFormatted = productVariantRef._formatMoney(
      unitPrice,
      KROWN.settings.shop_money_format
    );

    document.querySelector(
      "[data-hidden-price-unit]"
    ).innerHTML = `${unitPriceFormatted} / ${variant.unit_price_measurement.reference_unit}`;
    document.querySelector(
      "[data-hidden-unit-quantity]"
    ).innerHTML = `${variant.unit_price_measurement.quantity_value}`;
    document.querySelector(
      "[data-hidden-reference-unit]"
    ).innerHTML = `${variant.unit_price_measurement.reference_unit}`;
    document.querySelector(
      "[data-hidden-quantity-unit]"
    ).innerHTML = `${variant.unit_price_measurement.quantity_unit}`;
    setCouponPrice(variant.price, document.querySelector("product-variants"));
  }

  setTimeout(function () {
    const radioOptionEl = document.querySelector(
      '[name="purchaseOption"]:checked'
    );
    if (!radioOptionEl) {
      return;
    }
    const radioOption = radioOptionEl.value;

    const priceDisplayEl = document.querySelector(
      "[data-js-product-price-original]"
    );

    let el = "";
    if (radioOption == "onetime") {
      el = document.querySelector(".onetime-radio .rc-radio__label");
    } else {
      el = document.querySelector(".subscription-radio .rc-radio__price");
    }

    let text = el.textContent;
    text = text.replace(/\D/g, "");
    const productVariants = document.querySelector("product-variants");
    let productPrice = Number(text);
    let price = productVariants._formatMoney(
      text,
      KROWN.settings.shop_money_format
    );
    priceDisplayEl.innerHTML = price;

    // unit price
    const unitPriceEl = document.querySelector("[data-hidden-price-unit]");
    const unitPriceQuantity = document.querySelector(
      "[data-hidden-unit-quantity]"
    );
    const referenceUnit = document.querySelector(
      "[data-hidden-reference-unit]"
    );
    const quantityUnit = document.querySelector("[data-hidden-quantity-unit]");

    let unitText = "";

    if (radioOption == "onetime") {
      unitText = unitPriceEl.textContent;
      unitText = unitText.replace(/\D/g, "");
    } else {
      if (quantityUnit.textContent.trim() == "g") {
        unitText = text / (unitPriceQuantity.textContent / 1000);
      } else if (quantityUnit.textContent.trim() == "l") {
        unitText = text / unitPriceQuantity.textContent;
      } else if (quantityUnit.textContent.trim() == "ml") {
        unitText = text / (unitPriceQuantity.textContent / 1000);
      }
    }

    const unitPrice = productVariants._formatMoney(
      unitText,
      KROWN.settings.shop_money_format
    );

    const unitEl = document.querySelector(
      ".product-actions .product-price--unit"
    );
    unitEl.innerHTML = `
              ${unitPrice} / 
              ${referenceUnit.textContent}
          `;
  }, 0);
}
*/

/* comment out on 10 Sep 2025 -> Becasue we have to show compare price when subscription select -> so below is the new code
function checkMainPriceDisplay(variant = false) {
  $('.subs_buttons').css('display','flex');
  //$('.subs_months_main').css('display','flex');
  
  console.log("display changes");
  const productVariants = document.querySelector("product-variants");

  // Initial updates if variant passed
  if (variant) {
    const unitPriceFormatted = productVariants._formatMoney(
      variant.unit_price,
      KROWN.settings.shop_money_format
    );

    document.querySelector("[data-hidden-price-unit]").innerHTML =
      `${unitPriceFormatted} / ${variant.unit_price_measurement.reference_unit}`;
    document.querySelector("[data-hidden-unit-quantity]").innerHTML =
      `${variant.unit_price_measurement.quantity_value}`;
    document.querySelector("[data-hidden-reference-unit]").innerHTML =
      `${variant.unit_price_measurement.reference_unit}`;
    document.querySelector("[data-hidden-quantity-unit]").innerHTML =
      `${variant.unit_price_measurement.quantity_unit}`;

    setCouponPrice(variant.price, productVariants);
  }

  setTimeout(function () {
    const radioOptionEl = document.querySelector('[name="purchaseOption"]:checked');
    if (!radioOptionEl) return;

    const radioOption = radioOptionEl.value;

    const priceDisplayEl = document.querySelector("[data-js-product-price-original]");

    let el;
    if (radioOption === "onetime") {
      el = document.querySelector(".onetime-radio .rc-radio__label");
    } else {
      el = document.querySelector(".subscription-radio .rc-radio__price");
    }

    if (!el) return;

    // --- Get current price from Recharge UI ---
    let text = el.textContent;
    text = text.replace(/\D/g, "");
    const currentPrice = Number(text);

    // Update displayed price
    const formattedPrice = productVariants._formatMoney(currentPrice, KROWN.settings.shop_money_format);
    priceDisplayEl.innerHTML = formattedPrice;

    // --- Update Unit Price ---
    const unitPriceEl = document.querySelector("[data-hidden-price-unit]");
    const unitQty = document.querySelector("[data-hidden-unit-quantity]");
    const refUnit = document.querySelector("[data-hidden-reference-unit]");
    const qtyUnit = document.querySelector("[data-hidden-quantity-unit]");

    let unitText = "";
    if (radioOption === "onetime") {
      unitText = unitPriceEl.textContent.replace(/\D/g, "");
    } else {
      if (qtyUnit.textContent.trim() === "g") {
        unitText = currentPrice / (unitQty.textContent / 1000);
      } else if (qtyUnit.textContent.trim() === "l") {
        unitText = currentPrice / unitQty.textContent;
      } else if (qtyUnit.textContent.trim() === "ml") {
        unitText = currentPrice / (unitQty.textContent / 1000);
      }
    }

    const unitFormatted = productVariants._formatMoney(unitText, KROWN.settings.shop_money_format);
    const unitEl = document.querySelector(".product-actions .product-price--unit");
    if (unitEl) {
      unitEl.innerHTML = `${unitFormatted} / ${refUnit.textContent}`;
    }


    // --- Rabatt % Badge ---
    const selectedVariant = productVariants.currentVariant;
    const discountEl = document.querySelector('.pricerabatt');
    if (discountEl && selectedVariant && selectedVariant.compare_at_price > currentPrice) {
      const discountValue = selectedVariant.compare_at_price - currentPrice;
      const discountPercent = Math.round((discountValue * 100) / selectedVariant.compare_at_price);
      discountEl.innerHTML = `${discountPercent}% Rabatt`;
    } else if (discountEl) {
      discountEl.innerHTML = '';
    }

    // --- Price Per Day ---
    const perDayEl = document.querySelector('.per_day_charge');
    if (perDayEl && selectedVariant) {
      const variantId = selectedVariant.id;
      const portionEl = document.querySelector(`.variant-portion-data[data-variant-id="${variantId}"]`);
      if (portionEl) {
        const portions = parseInt(portionEl.dataset.portionen, 10);
        if (!isNaN(portions) && portions > 0) {
          const pricePerDay = currentPrice / portions;
          const perDayFormatted = productVariants._formatMoney(pricePerDay, KROWN.settings.shop_money_format);
          perDayEl.innerHTML = `nur ${perDayFormatted} am Tag`;
        } else {
          perDayEl.innerHTML = '';
        }
      } else {
        perDayEl.innerHTML = '';
      }
    }

  }, 0);
}
*/

function checkMainPriceDisplay(variant = false) {
  $('.subs_buttons').css('display','flex');
  console.log("display changes");
  const productVariants = document.querySelector("product-variants");

  // Initial updates if variant passed
  if (variant) {
    const unitPriceFormatted = productVariants._formatMoney(
      variant.unit_price,
      KROWN.settings.shop_money_format
    );

    document.querySelector("[data-hidden-price-unit]").innerHTML =
      `${unitPriceFormatted} / ${variant.unit_price_measurement.reference_unit}`;
    document.querySelector("[data-hidden-unit-quantity]").innerHTML =
      `${variant.unit_price_measurement.quantity_value}`;
    document.querySelector("[data-hidden-reference-unit]").innerHTML =
      `${variant.unit_price_measurement.reference_unit}`;
    document.querySelector("[data-hidden-quantity-unit]").innerHTML =
      `${variant.unit_price_measurement.quantity_unit}`;

    setCouponPrice(variant.price, productVariants);
  }

  setTimeout(function () {
    const radioOptionEl = document.querySelector('[name="purchaseOption"]:checked');
    if (!radioOptionEl) return;

    const radioOption = radioOptionEl.value;
    const priceDisplayEl = document.querySelector("[data-js-product-price-original]");
    const comparePriceEl = document.querySelector(".product-price--compare");

    let el;
    if (radioOption === "onetime") {
      el = document.querySelector(".onetime-radio .rc-radio__label");
    } else {
      el = document.querySelector(".subscription-radio .rc-radio__price");
    }

    if (!el) return;

    // --- Get current price from Recharge UI ---
    let text = el.textContent;
    text = text.replace(/\D/g, "");
    const currentPrice = Number(text);

    // Update displayed price
    const formattedPrice = productVariants._formatMoney(currentPrice, KROWN.settings.shop_money_format);
    priceDisplayEl.innerHTML = formattedPrice;

    // --- Update Unit Price ---
    const unitPriceEl = document.querySelector("[data-hidden-price-unit]");
    const unitQty = document.querySelector("[data-hidden-unit-quantity]");
    const refUnit = document.querySelector("[data-hidden-reference-unit]");
    const qtyUnit = document.querySelector("[data-hidden-quantity-unit]");

    let unitText = "";
    if (radioOption === "onetime") {
      unitText = unitPriceEl.textContent.replace(/\D/g, "");
    } else {
      if (qtyUnit.textContent.trim() === "g") {
        unitText = currentPrice / (unitQty.textContent / 1000);
      } else if (qtyUnit.textContent.trim() === "l") {
        unitText = currentPrice / unitQty.textContent;
      } else if (qtyUnit.textContent.trim() === "ml") {
        unitText = currentPrice / (unitQty.textContent / 1000);
      }
    }

    const unitFormatted = productVariants._formatMoney(unitText, KROWN.settings.shop_money_format);
    const unitEl = document.querySelector(".product-actions .product-price--unit");
    if (unitEl) {
      unitEl.innerHTML = `${unitFormatted} / ${refUnit.textContent}`;
    }

    // --- Rabatt % Badge ---
    const selectedVariant = productVariants.currentVariant;
    const discountEl = document.querySelector('.pricerabatt');
    if (discountEl && selectedVariant && selectedVariant.compare_at_price > currentPrice) {
      const discountValue = selectedVariant.compare_at_price - currentPrice;
      const discountPercent = Math.round((discountValue * 100) / selectedVariant.compare_at_price);
      discountEl.innerHTML = `${discountPercent}% Rabatt`;
    } else if (discountEl) {
      discountEl.innerHTML = '';
    }

    // --- Show compare price for subscription if none exists ---
    if (comparePriceEl && radioOption === "subscription") {
      let compareFormatted;
      if (!selectedVariant.compare_at_price || selectedVariant.compare_at_price <= 0) {
        // use main variant price as compare
        compareFormatted = productVariants._formatMoney(selectedVariant.price, KROWN.settings.shop_money_format);
      } else {
        // use actual compare price
        compareFormatted = productVariants._formatMoney(selectedVariant.compare_at_price, KROWN.settings.shop_money_format);
      }

      /* Latest Comment Nov 11 25
      comparePriceEl.outerHTML = `
        <del class="product-price--compare" style="text-decoration: line-through;" data-js-product-price-compare="">
          ${compareFormatted}
        </del>
      `;
      */
    } else if (comparePriceEl && radioOption === "onetime") {
      // Reset / remove compare if not applicable
      /* Latest Comment Nov 11 25
      comparePriceEl.outerHTML = `
        <del class="product-price--compare" style="text-decoration: line-through;" data-js-product-price-compare=""></del>
      `;
      */
    }


    // --- Price Per Day ---
    const perDayEl = document.querySelector('.per_day_charge');
    if (perDayEl && selectedVariant) {
      const variantId = selectedVariant.id;
      const portionEl = document.querySelector(`.variant-portion-data[data-variant-id="${variantId}"]`);
      if (portionEl) {
        const portions = parseInt(portionEl.dataset.portionen, 10);
        if (!isNaN(portions) && portions > 0) {
          const pricePerDay = currentPrice / portions;
          const perDayFormatted = productVariants._formatMoney(pricePerDay, KROWN.settings.shop_money_format);
          perDayEl.innerHTML = `nur ${perDayFormatted} am Tag`;
        } else {
          perDayEl.innerHTML = '';
        }
      } else {
        perDayEl.innerHTML = '';
      }
    }

  }, 0);
}

